module.exports = __webpack_public_path__ + "static/media/MTL_ASC_SUP3.bc0bceea.png";